import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_1 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1b2860d870cb767bfd4b4d2b87407381.js')["default"];

var scope_2 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/22cd1b6259767b20b0a6620af550b9f9.js')["default"];

var scope_3 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2546ba6a0031fa4bd476e05b1b17c3c7.js')["default"];

var scope_4 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3f962cd2ad87f131450ca8da54a97060.js')["default"];

var scope_5 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/888243cdadd8d2d0ead727f83d34024e.js')["default"];

var scope_6 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8bc40adc6b7f42e6846c4fb0528e8b3c.js')["default"];

var scope_7 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/97cef62b29fe64a331bef20f8eb5db44.js')["default"];

var scope_8 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9f4137af10e568e4c6d1b8a9e698dbd4.js')["default"];

var scope_9 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a201d9c59f9b40ff598b4f3fd39fafc8.js')["default"];

var scope_10 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b0f63163cb97b3f0db31019783886899.js')["default"];

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10);